<div style="margin-left: 5vw; margin-top: 10vh; width: 90vw; min-width: 90vw; padding-bottom: 5vh">
   <form [formGroup]="form" (ngSubmit)="onFilter()" class="inline-form">
      <mat-form-field appearance="standard">
         <mat-label>{{ 'Id' | translate }}</mat-label>
         <input matInput formControlName="id" />
      </mat-form-field>
      <mat-form-field appearance="standard">
         <mat-label>{{ 'Modified by' | translate }}</mat-label>
         <input matInput formControlName="modifyingUser" />
      </mat-form-field>

      <button mat-raised-button color="secondary" type="submit" [disabled]="form.invalid">
         {{ 'Search' | translate }}
      </button>

      <button mat-raised-button color="warn" type="reset" (click)="onClearFilter()">
         {{ 'Clear filter' | translate }}
      </button>
   </form>

   <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%">
      <ng-container matColumnDef="id">
         <th mat-header-cell *matHeaderCellDef> # </th>
         <td mat-cell *matCellDef="let row"> {{ row.id }} </td>
      </ng-container>

      <ng-container matColumnDef="columnName">
         <th mat-header-cell *matHeaderCellDef> {{ 'Field name' | translate }} </th>
         <td mat-cell *matCellDef="let row"> {{ row.columnName }} </td>
      </ng-container>

      <ng-container matColumnDef="oldValue">
         <th mat-header-cell *matHeaderCellDef> {{ 'Previous value' | translate }} </th>
         <td mat-cell *matCellDef="let row"> {{ row.oldValue }} </td>
      </ng-container>

      <ng-container matColumnDef="newValue">
         <th mat-header-cell *matHeaderCellDef style="max-width: 80vh">
            {{ 'New value' | translate }}
         </th>
         <td mat-cell *matCellDef="let row" style="max-width: 80vh; overflow: hidden">
            {{ row.newValue }}
         </td>
      </ng-container>

      <ng-container matColumnDef="modifyingUser">
         <th mat-header-cell *matHeaderCellDef> {{ 'Modified by' | translate }} </th>
         <td mat-cell *matCellDef="let row"> {{ row.modifyingUser }} </td>
      </ng-container>
      <ng-container matColumnDef="modificationDate">
         <th mat-header-cell *matHeaderCellDef> {{ 'Date' | translate }} </th>
         <td mat-cell *matCellDef="let row"> {{ convertDateAndTime(row.modificationDate) }} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
   </table>
   <mat-paginator
      [length]="total"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]"
      aria-label="Select page"
      [pageIndex]="page"
      (page)="onPageChange($event)"
   >
   </mat-paginator>
</div>
